export class Media {
  Id: number = 0;
  ProjectId: number = 0;
  Url?: string;
  Type: number | string = 0;
  OriginalName?: string;
  OriginalSize?: string;
  ImageRatio: number = 0;
  Updated?: Date;
  Alt?: string;
  Width?: number;
  ThumbnailUrl?: string;
  VideoUrlDesktop?: string;
  VideoUrlMobile?: string;
  Uploaded: boolean = false;
}
